import { render, staticRenderFns } from "./AddActionItemModal.vue?vue&type=template&id=6e83674c&"
import script from "./AddActionItemModal.vue?vue&type=script&lang=ts&"
export * from "./AddActionItemModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports